import type { LookupFlow } from './types'

export function detectFlow(route: string): LookupFlow {
  if (route.includes('ktn')) return 'ktn'
  if (route.includes('status')) return 'app-status'
  return 'ktn'
}

export function formatReason(err: unknown): string {
  if (!err || typeof err !== 'object') return 'Unknown error'

  const e = err as Record<string, unknown>

  if (typeof e.message === 'string' && e.message !== '') {
    return e.message
  }

  if (typeof e.statusText === 'string' && e.statusText !== '') {
    return e.statusText
  }

  if (typeof e.status === 'number') {
    return `HTTP ${e.status}`
  }

  if (e.name === 'TypeError') {
    return 'Network error'
  }

  return 'Unknown error'
}

export function formatMeta(err: unknown): Record<string, string> {
  if (typeof err !== 'object' || !err) return {}

  const e = err as Record<string, unknown>
  const result: Record<string, string> = {}

  if (typeof e.message === 'string') result.message = e.message
  if (typeof e.statusText === 'string') result.statusText = e.statusText
  if (e.status != null) result.status = String(e.status)
  if (typeof e.url === 'string') result.url = e.url
  if (typeof e.type === 'string') result.type = e.type
  if (typeof e.name === 'string') result.name = e.name

  return result
}
